import React, { useState, useEffect } from 'react'
// import DPSDatepickerComponent from '../../base/datepicker/DPSDatepickerComponent'
import Chart from 'react-apexcharts'
import './ChallengeOverview.css'
import DpsButton from '../../base/button/DpsButton'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import DpsSidePanel from '../../base/sidepanel/DpsSidePanel'
import useAPIEndpoints from '../../../../models/api/apiEndpoints'
import dayjs from 'dayjs'
import { useAuthStore } from '../../../../store/useStore'
import { useFetch } from '../../../../models/api/api'
import { CircularProgress } from '@mui/material'
import ChallengeOverViewGrid from '../../base/grid/ChallengeOverViewGrid'
const ChallengeOverview = ({
  token,
  setToken,
  GridComponent,
  gridProps,
  GridPageSizeComponent,
  GridPageSizeProps,
  MultiSelectDateTimepicker,
  startDateProps,
  endDateProps,
  exportData,
  isDatesValid,
  contractId,
}) => {
  const today = dayjs()
  const fifteenDaysAgo = dayjs().subtract(15, 'day')
  const [dateRange, setDateRange] = useState([fifteenDaysAgo, today])
  const [selectedAgentTab, setSelectedAgentTab] = useState('VRM')
  const [animateBars, setAnimateBars] = useState(false)
  const [sidePanelOpen, setSidePanelOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const APIEndPoints = useAPIEndpoints()
  const [selectedCouncil, setSelectedCouncil] = useState(contractId)
  const [validationAccuracyResults, setValidationAccuracyResults] = useState([])
  const [agentInterventionsCount, setAgentInterventionsCount] = useState([])
  const [summaryDetails, setSummaryDetails] = useState([])
  const [ocrResults, setOcrResults] = useState([])
  const { fetchData } = useFetch()
  const ocrResultsArray = Array.isArray(ocrResults)
    ? ocrResults
    : Object.entries(ocrResults).map(([label, value]) => ({ label, value }))
  const triggerDateFilter =
    isDatesValid && startDateProps?.value && endDateProps?.value
  const customizedOCRResults = ocrResultsArray.map((item) => {
    if (
      item.label.toLocaleLowerCase() === 'email' ||
      item.label.toLocaleLowerCase() === 'overall' ||
      item.label.toLocaleLowerCase() === 'image'
    ) {
      return {
        ...item,
        value: Math.round(item.value),
      }
    }
    return item
  })
  const ocrGraphData = customizedOCRResults.filter(
    (item) =>
      item.label.toLocaleLowerCase() === 'email' ||
      item.label.toLocaleLowerCase() === 'image'
  )
  const { setAuth, bearer } = useAuthStore()
  // Helper to format dates for API calls
  const getDateRange = () => {
    const [start, end] = dateRange

    // If the date picker returns a Dayjs object, extract JS Date with .$d
    const startDate = startDateProps?.value //start?.$d || new Date()
    const endDate = endDateProps?.value //end?.$d || new Date()

    const formatDate = (date) => {
      const d = new Date(date)
      return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(
        2,
        '0'
      )}/${String(d.getDate()).padStart(2, '0')}`
    }
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    }
  }
  useEffect(() => {
    // Trigger animation after mount
    const timer = setTimeout(() => setAnimateBars(true), 100)
    return () => clearTimeout(timer)
  }, [])
  useEffect(() => {
    if (token) {
      setAuth({ bearer: token, idToken: null }) // ✅ set token
    }
    const loadData = async () => {
      setIsLoading(true)
      try {
        setSelectedCouncil(contractId)
      } catch (err) {
        console.log(err)
      }
    }
    loadData()
  }, [token, contractId])

  const fetchValidationAccuracy = (contractId) => {
    const { startDate, endDate } = getDateRange()
    fetchValid(contractId, startDate, endDate)
    fetchOCRResults(contractId, startDate, endDate)
    fetchAgentsInterventionsCount(contractId, startDate, endDate)
    fetchSummaryResults(contractId, startDate, endDate)
    setIsLoading(false)
  }
  const fetchValid = async (contractId, startDate, endDate) => {
    const response = await fetchData(
      APIEndPoints.GetValidationAccuracyByContractid.method,
      `${
        APIEndPoints.GetValidationAccuracyByContractid.url
      }?contractId=${contractId}&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`
    )
    if (response?.data && response.data.length > 0) {
      setValidationAccuracyResults(response.data)
    }
  }
  const fetchOCRResults = async (contractId, startDate, endDate) => {
    const response = await fetchData(
      APIEndPoints.GetOcrResultsByContractid.method,
      `${
        APIEndPoints.GetOcrResultsByContractid.url
      }?contractId=${contractId}&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`
    )
    if (response?.data) {
      setOcrResults(response.data)
    }
  }
  const fetchSummaryResults = async (contractId, startDate, endDate) => {
    const response = await fetchData(
      APIEndPoints.GetWeeklySummaryReport.method,
      `${
        APIEndPoints.GetWeeklySummaryReport.url
      }?contractId=${contractId}&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`
    )
    if (response?.data && response.data.length > 0) {
      setSummaryDetails(response.data)
    }
  }
  const fetchAgentsInterventionsCount = async (
    contractId,
    startDate,
    endDate
  ) => {
    const response = await fetchData(
      APIEndPoints.GetOverrideReasonCountByContractid.method,
      `${
        APIEndPoints.GetOverrideReasonCountByContractid.url
      }?contractId=${contractId}&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`
    )
    if (response?.data && response.data.length > 0) {
      setAgentInterventionsCount(response.data)
    }
  }

  useEffect(() => {
    if (selectedCouncil) {
      fetchValidationAccuracy(selectedCouncil)
    }
  }, [selectedCouncil, triggerDateFilter])

  const validationAccuracySeries = [
    {
      name: 'Valid',
      data: validationAccuracyResults.map((item) => item.validCount),
    },
    {
      name: 'Not valid',
      data: validationAccuracyResults.map((item) => item.notValidCount),
    },
    {
      name: "Can't valid",
      data: validationAccuracyResults.map((item) => item.cannotValidateCount),
    },
  ]

  const validationAccuracyOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      animations: { enabled: true },
    },
    plotOptions: { bar: { horizontal: true } },
    xaxis: { categories: ['VRM', 'Make & Color'] },
    colors: ['#3276CF', '#D968AF', '#FF8A65'],
    legend: { show: false },
    dataLabels: { enabled: false },
    states: {
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
        },
      },
    },
  }

  // Summarisation results bar chart
  const summarisationSeries = [
    {
      name: 'Results',
      data: (summaryDetails || []).map((item) => {
        const val = item.totalComplaints
        return isNaN(Number(val)) ? 0 : Number(val)
      }),
    },
  ]

  const formattedCategories = (summaryDetails || []).map((item) => {
    if (item.periodType === 'Day') {
      const match = item.periodRange.match(/\((.*?)\)/)

      if (match && match[1]) {
        const parts = match[1].split('/')
        const day = parts[1]
        const month = parts[3]
        return `${day}/${month}`
      }

      return item.periodRange
    }

    return item.periodRange
  })

  const summarisationOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: { enabled: true },
    },
    plotOptions: {
      bar: {
        columnWidth: '40%', // reduce bar width (default is '70%')
      },
    },
    xaxis: {
      categories: formattedCategories || [],
      labels: {
        rotate: -45,
        style: {
          fontSize: '12px',
          colors: '#666',
        },
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: (val) => `${val}`, // show plain numbers
        style: {
          fontSize: '12px',
          colors: ['#757575'],
        },
      },
    },
    colors: ['#3276CF'],
    dataLabels: { enabled: false },
  }

  const agentTabs = ['VRM', 'Make & Colour']

  const reasonTypeMap = {
    VRM: 'VRM',
    'Make & Colour': 'MakeAndColor', // map UI tab name to API key
  }

  const agentPieLabels =
    selectedAgentTab === 'VRM'
      ? [
          'CEO inputted incorrectly',
          'AI/Bot Misread',
          'VRM has been tampered with',
          'ANPR Misread',
        ]
      : [
          'CEO inputted incorrect Make',
          'AI/Bot Misread Make',
          'ANPR Misread Make',
          'CEO inputted incorrect Colour',
          'AI/Bot Misread Colour',
          'ANPR Misread Colour',
          'CEO inputted incorrect Make & Colour',
          'AI/Bot Misread Make & Colour',
          'ANPR Misread Make & Colour',
        ]

  const mapCountsToLabels = (data, labels, type) => {
    const filtered = data.filter((item) => item.reasonType === type)

    return labels.map((label) => {
      const found = filtered.find((item) => item.reason.trim() === label.trim())
      return found ? found.totalCount : 0
    })
  }

  const agentPieData = {
    VRM: {
      series: mapCountsToLabels(
        agentInterventionsCount,
        [
          'CEO inputted incorrectly',
          'AI/Bot Misread',
          'VRM has been tampered with',
          'ANPR Misread',
        ],
        reasonTypeMap['VRM']
      ),
      colors: ['#3276CF', '#B46CC3', '#F26B96', '#FF8A65'],
      counts: mapCountsToLabels(
        agentInterventionsCount,
        [
          'CEO inputted incorrectly',
          'AI/Bot Misread',
          'VRM has been tampered with',
          'ANPR Misread',
        ],
        reasonTypeMap['VRM']
      ),
    },
    'Make & Colour': {
      series: mapCountsToLabels(
        agentInterventionsCount,
        [
          'CEO inputted incorrect Make',
          'AI/Bot Misread Make',
          'ANPR Misread Make',
          'CEO inputted incorrect Colour',
          'AI/Bot Misread Colour',
          'ANPR Misread Colour',
          'CEO inputted incorrect Make & Colour',
          'AI/Bot Misread Make & Colour',
          'ANPR Misread Make & Colour',
        ],
        reasonTypeMap['Make & Colour']
      ),
      colors: [
        '#4A90E2',
        '#B97AFF',
        '#F5A623',
        '#F8E71C',
        '#3276CF',
        '#B46CC3',
        '#F26B96',
        '#FF8A65',
        '#3276CF',
      ],
      counts: mapCountsToLabels(
        agentInterventionsCount,
        [
          'CEO inputted incorrect Make',
          'AI/Bot Misread Make',
          'ANPR Misread Make',
          'CEO inputted incorrect Colour',
          'AI/Bot Misread Colour',
          'ANPR Misread Colour',
          'CEO inputted incorrect Make & Colour',
          'AI/Bot Misread Make & Colour',
          'ANPR Misread Make & Colour',
        ],
        reasonTypeMap['Make & Colour']
      ),
    },
  }

  const agentPieSeries = agentPieData[selectedAgentTab].series
  const agentPieColors = agentPieData[selectedAgentTab].colors
  const agentPieCountsFinal = agentPieData[selectedAgentTab].counts
  const agentPieLabelsFinal = agentPieLabels

  const agentPieOptions = {
    chart: { type: 'donut', animations: { enabled: true } },
    labels: agentPieLabels,
    colors: agentPieColors,
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
  }

  const columnData = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      type: 'date',
      valueGetter: (params) => {
        const value = params
        return value ? new Date(value) : null
      },
      renderCell: (params) => {
        return (
          <span>
            {params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'}
          </span>
        )
      },
    },
    { field: 'pcnNumber', headerName: 'PCN', flex: 1, type: 'string' },
    { field: 'agentName', headerName: 'Agent', flex: 1, type: 'string' },
    { field: 'validation', headerName: 'Validation', flex: 1, type: 'string' },
    {
      field: 'notes',
      headerName: 'Notes',
      flex: 4,
      minWidth: 200,
      type: 'string',
    },
    {
      field: 'valid',
      headerName: 'Valid?',
      type: 'singleSelect',
      valueOptions: ['Yes', 'No'],
      flex: 1,
    },
  ]

  return (
    <>
      {isLoading ? (
        <CircularProgress className="loading-indicator" />
      ) : (
        <div className="challenge-overview-container">
          <div className="challenge-header">
            <h2>Challenge Overview</h2>
            <div className="challenge-summary-controls"></div>
            <div className="challenge-options">
              <div className="date-picker-container">
                <div className="start-date">
                  <MultiSelectDateTimepicker {...startDateProps} />
                </div>
                <div className="end-date">
                  <MultiSelectDateTimepicker {...endDateProps} />
                </div>
              </div>
            </div>
          </div>

          <div className="challenge-top-row">
            <div className="challenge-validation-card">
              <div className="challenge-card-header">
                <span>Validation Accuracy</span>
              </div>
              <Chart
                options={validationAccuracyOptions}
                series={validationAccuracySeries}
                type="bar"
                height={110}
              />
              <div className="challenge-bar-legend">
                <div style={{ color: '#3276CF' }}>
                  ■ <span style={{ color: '#757575' }}>Valid</span>
                </div>
                <div style={{ color: '#D968AF' }}>
                  ■ <span style={{ color: '#757575' }}>Not valid</span>
                </div>
                <div style={{ color: '#FF8A65' }}>
                  ■ <span style={{ color: '#757575' }}>Can't valid</span>
                </div>
              </div>
            </div>

            <div className="challenge-ocr-card">
              <div className="challenge-card-header">
                <span>OCR Results</span>
              </div>

              <div className="challenge-ocr-main">
                <span className="challenge-ocr-percent">
                  {customizedOCRResults.find(
                    (r) => r.label.toLowerCase() === 'overall'
                  )?.value || 0}
                  %
                </span>
              </div>

              <div className="challenge-ocr-divider" />

              <div className="challenge-ocr-bars">
                {ocrGraphData.map((item) => (
                  <div key={item.label} className="challenge-ocr-bar-row">
                    <span className="challenge-ocr-bar-label">
                      {item.label
                        ? item.label.charAt(0).toUpperCase() +
                          item.label.slice(1)
                        : ''}
                    </span>

                    <div className="challenge-ocr-bar-track">
                      <div
                        className="challenge-ocr-bar-fill"
                        style={{
                          width: animateBars ? `${item.value}%` : '0%',
                          background: '#3276CF',
                          transition: 'width 1s cubic-bezier(0.4,0,0.2,1)',
                        }}
                      />
                    </div>

                    <div className="challenge-ocr-bar-right">
                      <span className="challenge-ocr-bar-value">
                        {item.value}%
                      </span>
                      {item.change && (
                        <span className="challenge-ocr-bar-change">
                          {item.change}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="challenge-bottom-row">
            <div className="challenge-summary-card">
              <div className="challenge-card-header">
                <span>Summarisation results</span>
              </div>

              <Chart
                options={summarisationOptions}
                series={summarisationSeries}
                type="bar"
                height={230}
              />
            </div>

            <div className="challenge-agents-card">
              <div className="challenge-card-header">
                <span>Agents Interventions</span>
                <DpsButton
                  buttonVariant="text"
                  label="VIEW MORE"
                  endAdronIcon={<KeyboardArrowRightIcon />}
                  onClick={() => {
                    setSidePanelOpen(true)
                  }}
                />
              </div>

              <div className="challenge-agents-tabs">
                {agentTabs.map((tab) => (
                  <button
                    key={tab}
                    className={selectedAgentTab === tab ? 'active' : ''}
                    onClick={() => setSelectedAgentTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="challenge-agents-chart-row">
                <Chart
                  options={agentPieOptions}
                  series={agentPieSeries}
                  type="donut"
                  height={190}
                  width={200}
                />

                <div className="challenge-agents-legend">
                  {agentPieLabelsFinal.map((label, idx) => (
                    <div className="challenge-agents-legend-row" key={label}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          className="challenge-agents-legend-dot"
                          style={{ background: agentPieColors[idx] }}
                        />
                        <span className="challenge-agents-legend-label">
                          {label}
                        </span>
                      </div>

                      <span className="challenge-agents-legend-count">
                        {agentPieCountsFinal[idx]}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <DpsSidePanel
            panStatus={sidePanelOpen}
            onClose={() => setSidePanelOpen(false)}
            sliderHeader="Agents Interventions"
            direction="right"
            width={800}
            SliderComponent={
              <div className="challenge-overview-grid-panel">
                <ChallengeOverViewGrid
                  GridComponent={GridComponent}
                  gridProps={gridProps}
                  GridPageSizeComponent={GridPageSizeComponent}
                  GridPageSizeProps={GridPageSizeProps}
                  exportData={exportData}
                />
              </div>
            }
          />
        </div>
      )}
    </>
  )
}

export default ChallengeOverview
